import { z } from "zod";

/** IANA timezone name (e.g. Asia/Kolkata). Defaults to UTC when omitted. */
export const IanaTimezoneSchema = z
  .string()
  .trim()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z0-9_+-]+(?:\/[A-Za-z0-9_+-]+)*$/, "Invalid timezone")
  .default("UTC");
